import script from "./ButtonFixedFilled.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonFixedFilled.vue?vue&type=script&setup=true&lang=js"

import "./ButtonFixedFilled.vue?vue&type=style&index=0&id=a3da72b6&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a3da72b6"]])

export default __exports__